/* eslint-disable import/prefer-default-export */
export const linkReferentialToAuditFormValuesSelector = (state) =>
  state.forms.link_referential_to_audits
